import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import { size } from 'lodash-es';

/**
 * Wrap any component to show a timed tooltip on click.
 * Example:
 * <ClickableTooltipWrapper message="Hello!"><Chip label="Click me" /></ClickableTooltipWrapper>
 */
function ClickableTooltipWrapper({
  message,
  children,
  timeoutMultiplier = 2000,
  ...rest
}) {
  const [open, setOpen] = useState(false);

  const messageLength = size(message);
  let timeout = 2000;
  if (messageLength > 50) {
    timeout = Math.min(5000, (messageLength - 50) * 50 + 2000);
  }

  const handleClick = (e) => {
    if (children.props.onClick) children.props.onClick(e);
    setOpen(true);
    setTimeout(() => setOpen(false), timeout);
  };

  return (
    <Tooltip
      {...rest}
      open={open}
      title={message}
      disableFocusListener
      disableHoverListener
      disableTouchListener>

      <IconButton
        size="small"
        onClick={handleClick}
        disableRipple
        disableFocusRipple
        sx={{ padding: 0 }}>
        {children}
      </IconButton>
    </Tooltip>
  );
}

ClickableTooltipWrapper.propTypes = {
  message: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  timeoutMultiplier: PropTypes.number,
};

export default ClickableTooltipWrapper;
